﻿// Visual Studio has support for JSDoc annotations like these, they make life a little easier
/**
 * @typedef AttendanceRow
 * @type {object}
 * @property {number} id - AttendancePeriodID
 * @property {object} controls - jQuery elements for attendanceTypeEel, attendanceTypeEelCodeTb, attendanceReasonEel, and commentTb
 */
/**
 * @typedef PeriodRowData
 * @type {object}
 * @property {AttendanceRow} Row
 * @property {number} AttendanceTypeID
 * @property {number} AttendanceReasonID
 * @property {string} Comment
 */
(
    function (skyward, $)
    {
        "use strict";

        skyward.attendanceEntryTools = skyward.attendanceEntryTools || {};

        var entryToolSelector = '#attendanceEntryTool_';
        var formControls;
        var allAttendancePeriodControls;
        var editableAttendancePeriodControls;
        var attendanceEntryErrorsDiv;
        var attendanceEntryContainerDiv;
        var attendancePeriodLowFilterHdn;
        var attendancePeriodHighFilterHdn;
        var attendancePeriodMinFilterHdn;
        var attendancePeriodMaxFilterHdn;
        var nameSelectorTb;
        var startPeriodAsteriskSpan;
        var endPeriodAsteriskSpan;
        var currentStudentAttendanceSelectedRow;
        var studentId;
        var studentAbsenceRequestId;
        var currentSchoolYearId;
        var studentNotEnrolledInDates = true;
        var dirtyPeriods;
        var controllerObject;
        var pageLoaded = false;
        var loadedWithAttendance;
        /** @type {{AttendancePeriodID: PeriodRowData}} */
        var validatePeriodAttendancePeriodIDs = {};

        /**
         * @param {JQuery} attendancePeriodRow - Attendance Period/Type/Reason/Comment
         * @returns {AttendanceRow} - collection of Attendance Period/Type/Reason/Comment
         */
        var getAttendancePeriodRowData = function (attendancePeriodRow)
        {
            var row = {};

            row.id = attendancePeriodRow.find('.attendancePeriodId').val();
            row.controls = {};

            row.controls.attendanceTypeEel = attendancePeriodRow.find('.codeEEL.attendanceEntryGridAttendanceType');
            row.controls.attendanceTypeEelCodeTb = row.controls.attendanceTypeEel.find('.codeEELCode'); // used for tabbing
            row.controls.attendanceReasonEel = attendancePeriodRow.find('.codeEEL.attendanceEntryGridAttendanceReason');
            row.controls.commentTb = attendancePeriodRow.find('.attendancePeriodCommentElement:not(.attendanceEntryGridAttendanceTeacherComment)');

            row.controls.OfficeCommentButtonsContainer = attendancePeriodRow.find('.officeCommentButtonsContainer');
            row.controls.HideCommentInTA = attendancePeriodRow.find('.hideInTAHidden');
            row.controls.HideCommentInAA = attendancePeriodRow.find('.hideInAAHidden');
            row.controls.HideCommentInSSA = attendancePeriodRow.find('.hideInSSAHidden');
            row.controls.HideCommentInFA = attendancePeriodRow.find('.hideInFAHidden:not(.hideInFAHiddenTeacher)');
            row.controls.HideCommentInSA = attendancePeriodRow.find('.hideInSAHidden:not(.hideInSAHiddenTeacher)');
            row.controls.HideTeacherCommentInFA = attendancePeriodRow.find('.hideInFAHidden.hideInFAHiddenTeacher');
            row.controls.HideTeacherCommentInSA = attendancePeriodRow.find('.hideInSAHidden.hideInSAHiddenTeacher');
            return row;
        };

        /**
         * @param {AttendanceRow} rowData - Attendance Period/Type/Reason/Comment
         * @returns {PeriodRowData} - collection of Attendance Period/Type/Reason/Comment
         */
        var getAttendancePeriodsValuesForRow = function (rowData)
        {
            return {
                Row: rowData,
                AttendanceTypeID: skyward.controls.getValue(rowData.controls.attendanceTypeEel),
                AttendanceReasonID: skyward.controls.getValue(rowData.controls.attendanceReasonEel),
                Comment: skyward.extensions.decodeHtml(skyward.controls.getValue(rowData.controls.commentTb)),
                HideCommentInTA: skyward.controls.getValue(rowData.controls.HideCommentInTA),
                HideCommentInAA: skyward.controls.getValue(rowData.controls.HideCommentInAA),
                HideCommentInSSA: skyward.controls.getValue(rowData.controls.HideCommentInSSA),
                HideCommentInFA: skyward.controls.getValue(rowData.controls.HideCommentInFA),
                HideCommentInSA: skyward.controls.getValue(rowData.controls.HideCommentInSA),
                HideTeacherCommentInFA: skyward.controls.getValue(rowData.controls.HideTeacherCommentInFA),
                HideTeacherCommentInSA: skyward.controls.getValue(rowData.controls.HideTeacherCommentInSA)
            };
        };

        var init = function (selector)
        {
            var jqSelector = $(selector);
            if (jqSelector.find(entryToolSelector + 'AttendanceTypeID').length != 0)
            {
                formControls = {};
                formControls.attendanceTypeEel = jqSelector.find(entryToolSelector + 'AttendanceTypeID');
                formControls.attendanceTypeEelCodeTb = formControls.attendanceTypeEel.find(entryToolSelector + 'AttendanceTypeID_code'); // used for tabbing
                formControls.attendanceReasonEel = jqSelector.find(entryToolSelector + 'AttendanceReasonID');
                formControls.startDateTb = jqSelector.find(entryToolSelector + 'StartDate');
                formControls.endDateTb = jqSelector.find(entryToolSelector + 'EndDate');
                formControls.startPeriodEel = jqSelector.find(entryToolSelector + 'StartPeriod');
                formControls.startPeriodEelCodeTb = formControls.startPeriodEel.find(entryToolSelector + 'StartPeriod_code'); // used for tabbing
                formControls.endPeriodEel = jqSelector.find(entryToolSelector + 'EndPeriod');
                formControls.endPeriodEelCodeTb = formControls.endPeriodEel.find(entryToolSelector + 'EndPeriod_code'); // used for tabbing
                formControls.allDayCkb = jqSelector.find(entryToolSelector + 'AllDay');

                formControls.commentTb = jqSelector.find(entryToolSelector + 'Comment');
                formControls.replyToGuardianTb = jqSelector.find(entryToolSelector + 'ReplyToGuardian');
                formControls.guardianComment = jqSelector.find(entryToolSelector + 'GuardianComment');
                formControls.dayComment = jqSelector.find(entryToolSelector + 'DayComment');
                formControls.dayCommentAttendanceCommentPrivacySettingContainer = jqSelector.find(entryToolSelector + 'DayCommentAttendanceCommentPrivacySettingContainer');
                formControls.commentAttendanceCommentPrivacySettingContainer = jqSelector.find(entryToolSelector + 'AttendanceCommentPrivacySettingContainer');
                formControls.dayCommentHideInFA = jqSelector.find(entryToolSelector + 'HideCommentInFA');
                formControls.dayCommentHideInSA = jqSelector.find(entryToolSelector + 'HideCommentInSA');
                formControls.dayCommentHideInTA = jqSelector.find(entryToolSelector + 'HideCommentInTA');
                formControls.dayCommentHideInAA = jqSelector.find(entryToolSelector + 'HideCommentInAA');
                formControls.dayCommentHideInSSA = jqSelector.find(entryToolSelector + 'HideCommentInSSA');

                formControls.periodCommentHideInFA = jqSelector.find(entryToolSelector + 'HideCommentInFA-PeriodComment');
                formControls.periodCommentHideInSA = jqSelector.find(entryToolSelector + 'HideCommentInSA-PeriodComment');
                formControls.periodCommentHideInTA = jqSelector.find(entryToolSelector + 'HideCommentInTA-PeriodComment');
                formControls.periodCommentHideInAA = jqSelector.find(entryToolSelector + 'HideCommentInAA-PeriodComment');
                formControls.periodCommentHideInSSA = jqSelector.find(entryToolSelector + 'HideCommentInSSA-PeriodComment');

                formControls.isGuardianNotifiedCkb = jqSelector.find(entryToolSelector + 'IsGuardianNotified');
                formControls.currentStudentBrowse = jqSelector.find(entryToolSelector + 'CurrentStudentBrowse');
                formControls.cancelBtn = jqSelector.find(entryToolSelector + 'cancel');
                formControls.saveBtn = jqSelector.find(entryToolSelector + 'save');
                formControls.saveAndBackBtn = jqSelector.find(entryToolSelector + 'saveBack');
                formControls.processRequestWithExistingAttendance = jqSelector.find(entryToolSelector + 'ProcessRequestWithExistingAttendance');
                formControls.attendanceEntryErrors = jqSelector.find(entryToolSelector + 'AttendanceEntryErrors');
                formControls.attachments = jqSelector.find(entryToolSelector + 'UploadFile');
                formControls.dayStatusOverrideEel = jqSelector.find(entryToolSelector + 'AttendanceTypeIDDayStatusOverride');
                formControls.dayStatusCalculatedEel = jqSelector.find(entryToolSelector + 'AttendanceTypeIDCalculatedDayStatus');
                formControls.useDayStatusOverrideCb = jqSelector.find(entryToolSelector + 'UseAttendanceTypeDayStatusOverride');
                formControls.useMetMinutesRequiredOverrideCb = jqSelector.find(entryToolSelector + 'UseMetMinutesRequiredOverride');
                formControls.metMinutesRequiredOverrideCb = jqSelector.find(entryToolSelector + 'MetMinutesRequiredOverride');
                formControls.getGeneratedAttendancePeriodsStartDate = function ()
                {
                    return jqSelector.find(entryToolSelector + 'GeneratedAttendancePeriods_StartDate');
                };
                formControls.getGeneratedAttendancePeriodsEndDate = function ()
                {
                    return jqSelector.find(entryToolSelector + 'GeneratedAttendancePeriods_EndDate');
                };

                var currentSchoolYearLbl = $('.currentSchoolYear');
                currentSchoolYearId = (currentSchoolYearLbl.hasClass('current')) ? currentSchoolYearLbl.attr('id') : null;
                studentId = jqSelector.find(entryToolSelector + 'StudentID').val();
                studentAbsenceRequestId = jqSelector.find(entryToolSelector + 'StudentAbsenceRequestID').val();
                attendanceEntryErrorsDiv = jqSelector.find(entryToolSelector + 'AttendanceEntryErrors');
                attendanceEntryContainerDiv = jqSelector.find(entryToolSelector + 'AttendanceQuickEntry');
                nameSelectorTb = jqSelector.find('#NameSelector_input');
                startPeriodAsteriskSpan = jqSelector.find(entryToolSelector + 'StartPeriodLabel > .requiredAsterisk');
                endPeriodAsteriskSpan = jqSelector.find(entryToolSelector + 'EndPeriodLabel > .requiredAsterisk');
                controllerObject = jqSelector.find(entryToolSelector + 'ControllerObject').val();

                formControls.attendanceTypeEel.on('eelComplete', setAttendancePeriodEels);
                formControls.attendanceReasonEel.on('eelComplete', setAttendancePeriodEels);
                formControls.startPeriodEel.on('eelComplete', setAttendancePeriodEels);
                formControls.endPeriodEel.on('eelComplete', setAttendancePeriodEels);
                formControls.commentTb.on('change', setAttendancePeriodEels);
                formControls.allDayCkb.on('change', setAttendancePeriodEels);
                formControls.commentAttendanceCommentPrivacySettingContainer.on('commentPrivacySettingsChanged', setAttendancePeriodEels);
                formControls.startDateTb.on('change', changeEndDate);
                formControls.endDateTb.on('change', validateDates);
                nameSelectorTb.on('keydown', tabOverride);
                formControls.cancelBtn.on('keydown', tabOverride);
                formControls.startDateTb.on('keydown', tabOverride);
                formControls.startPeriodEelCodeTb.on('keydown', tabOverride);
                formControls.isGuardianNotifiedCkb.on('keydown', tabOverride);
                formControls.cancelBtn.on('click', validateDates);
                jqSelector.find(entryToolSelector + 'CurrentStudentBrowse').on('click', 'tr.browseRow', toggleCurrentRow);
                var focusToAllDayHdn = jqSelector.find(entryToolSelector + 'FocusToAllDayOnLoad');
                if (focusToAllDayHdn && focusToAllDayHdn.val() === 'True')
                {
                    formControls.allDayCkb.focus();
                }
                else
                {
                    nameSelectorTb.focus();
                }

                if (isStudentAbsenceRequest())
                {
                    //This won't mess with tabbing, that only trigggers on the keydown event
                    $(this).off('change dirty keyup').on('change dirty keyup', toggleVisibilityProcessRequestWithExistingAttendance);
                }
                formControls.processRequestWithExistingAttendance.off().on('click', attendanceEntryToolAddEntryProcessRequestWithExistingAttendance)
                                                                       .on('keydown', tabOverride);
                formControls.saveBtn.off().on('click', attendanceEntryToolAddEntrySave);
                formControls.saveAndBackBtn.off().on('click', attendanceEntryToolAddEntrySaveAndBack);
                skyward.changeTracking.clearDirtyList();
                hideErrors();
            }

            // Register controls for the attendance period grid only on the attendance tool load
            if (jqSelector.find('.attendanceToolEntryTable').length > 0)
            {
                attendancePeriodLowFilterHdn = jqSelector.find(entryToolSelector + 'AttendancePeriodLowFilter');
                attendancePeriodHighFilterHdn = jqSelector.find(entryToolSelector + 'AttendancePeriodHighFilter');
                attendancePeriodMinFilterHdn = jqSelector.find(entryToolSelector + 'AttendancePeriodMinFilter');
                attendancePeriodMaxFilterHdn = jqSelector.find(entryToolSelector + 'AttendancePeriodMaxFilter');

                // Attach event handlers to ensure that the attendance period high & low filters can't have a value of ''
                // The framework does this when someone clicks out of the start/end period eels without selecting a value
                attendancePeriodLowFilterHdn.off("change", assertValueNotEmpty).on("change", assertValueNotEmpty);
                attendancePeriodHighFilterHdn.off("change", assertValueNotEmpty).on("change", assertValueNotEmpty);

                var attendancePeriodRows = $('.attendanceEntryTable .attendancePeriodRow');
                editableAttendancePeriodControls = [];
                allAttendancePeriodControls = [];

                attendancePeriodRows.each(function ()
                {
                    var attendancePeriodRow = getAttendancePeriodRowData($(this));
                    var attendanceTypeEEL = attendancePeriodRow.controls.attendanceTypeEel.find('input.attendancePeriodTypeElement');

                    if (getPartIsEnabled(attendanceTypeEEL))
                    {
                        attendanceTypeEEL.parents('.attendanceEntryGridAttendanceType').on('eelComplete', attendanceTypeUpdate);

                        editableAttendancePeriodControls.push(attendancePeriodRow);
                    }
                    allAttendancePeriodControls.push(attendancePeriodRow);
                });

                // custom tabbing
                if (editableAttendancePeriodControls[0])
                {
                    editableAttendancePeriodControls[0].controls.attendanceTypeEelCodeTb.on('keydown', tabOverride);
                    editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.attendanceTypeEelCodeTb.on('keydown', tabOverride);
                    editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.commentTb.on('keydown', tabOverride);
                }

                var formValues = getCurrentFormValues();
                if (!studentAbsenceRequestId && (formValues.allDay || formValues.startPeriodId && formValues.endPeriodId))
                {
                    setAttendancePeriodEels();
                }
            }

            // DOM element(s) loading contain the AttendancePeriodForm the element actually *is* the Form
            if (jqSelector.find('.attendancePeriodFormContainer').length || jqSelector.is('.attendancePeriodFormContainer'))
            {
                studentNotEnrolledInDates = (skyward.controls.getValue(jqSelector.find(entryToolSelector + 'DisablePeriodEELs')) || '').toLowerCase() === 'true';
                formControls.attendanceEntryTable = jqSelector.find('.attendanceEntryTable');
                formControls.attendanceEntryTable.off('change').on('change', attendanceEntryTableChange);
                periodEELControlsRenderManager();
                validateDates();
            }

            if (jqSelector.find('.currentStudentAttendanceTable').length > 0)
            {
                currentStudentAttendanceSelectedRow = jqSelector.find('.currentStudentAttendanceTable .current');
            }

            if (!pageLoaded && isStudentAbsenceRequest() && hasAttendanceValues())
            {
                loadedWithAttendance = true;
            }

            pageLoaded = true;
        };

        /**
         * This function is used to keep the hidden AttendancePeriod high/low filters
         * from having a value of an empty string as this causes the codeeel browses for the
         * start & end periods to break. It's called when the value of those filters change.
         */
        var assertValueNotEmpty = function ()
        {
            let currentValue = skyward.controls.getValue(this);
            if (typeof currentValue === "string" && currentValue.length === 0)
            {
                let origValue = skyward.controls.getOriginalValue(this);
                skyward.controls.setValue(this, origValue);
            }
        }

        var isStudentAbsenceRequest = function ()
        {
            return studentAbsenceRequestId && studentAbsenceRequestId !== "";
        };

        var hasAttendanceValues = function ()
        {
            var values = getCurrentAttendancePeriodValues();

            if (!values || !values.length)
            {
                return false;
            }

            var attendanceEntered = false;
            $.each(values, function (index, value)
            {
                if (value.attendanceTypeId)
                {
                    attendanceEntered = true;
                    return false;
                }
            });

            return attendanceEntered;
        };

        var dirtySaveControls = function ()
        {
            if (formControls === undefined || formControls.processRequestWithExistingAttendance.is(':visible') == true)
            {
                return {};
            }

            var checkAddDirtyClass = function (button)
            {
                if (button && !button.hasClass("dirty"))
                {
                    button.addClass("dirty");
                }
            };

            checkAddDirtyClass(formControls.saveBtn);
            checkAddDirtyClass(formControls.saveAndBackBtn);
            checkAddDirtyClass(formControls.cancelBtn);
        };

        var getCurrentFormValues = function ()
        {
            // Ensure formControls has been initalized
            if (formControls === undefined)
            {
                return {};
            }

            var values = {};
            values.attendanceTypeId = skyward.controls.getValue(formControls.attendanceTypeEel);
            values.attendanceReasonId = skyward.controls.getValue(formControls.attendanceReasonEel);
            values.startDate = formControls.startDateTb.encodedVal();
            values.endDate = formControls.endDateTb.encodedVal();
            values.startPeriodId = skyward.controls.getValue(formControls.startPeriodEel);
            values.endPeriodId = skyward.controls.getValue(formControls.endPeriodEel);
            values.allDay = skyward.controls.getValue(formControls.allDayCkb);
            values.isGuardianNotified = skyward.controls.getValue(formControls.isGuardianNotifiedCkb);
            values.useAttendanceTypeDayStatusOverride = skyward.controls.getValue(formControls.useDayStatusOverrideCb);
            values.attendanceTypeIDDayStatusOverride = skyward.controls.getValue(formControls.dayStatusOverrideEel);
            values.comment = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.commentTb));
            values.dayComment = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayComment));
            values.dayCommentHideInFA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInFA));
            values.dayCommentHideInSA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInSA));
            values.dayCommentHideInTA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInTA));
            values.dayCommentHideInAA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInAA));
            values.dayCommentHideInSSA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInSSA));

            values.useMetMinutesRequiredOverride = skyward.controls.getValue(formControls.useMetMinutesRequiredOverrideCb);
            values.metMinutesRequiredOverride = skyward.controls.getValue(formControls.metMinutesRequiredOverrideCb);
           
            values.periodCommentHideInFA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInFA));
            values.periodCommentHideInSA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInSA));
            values.periodCommentHideInTA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInTA));
            values.periodCommentHideInAA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInAA));
            values.periodCommentHideInSSA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInSSA));

            values.replyToGuardian = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.replyToGuardianTb));

            values.warninghash = attendanceEntryContainerDiv.data('warninghash');

            return values;
        };

        /**
         * Note: Sets "dirtyPeriods" to true if any of the Attendance Period values found are dirty
         * @returns {attendancePeriodValues} - collection of Attendance Period/Type/Reason/Comment
         */
        var getCurrentAttendancePeriodValues = function ()
        {
            var attendancePeriodValues = [];
            if (!editableAttendancePeriodControls || editableAttendancePeriodControls.length < 1)
            {
                return;
            }
            $.each(editableAttendancePeriodControls, function (index, row)
            {
                var allValues = getAttendancePeriodsValuesForRow(row);

                // The values object is deliberately constructed as a copy of allValues (minus most properties) to avoid
                // including more than we need on it since it will be serialized and sent over the wire
                var values = {};
                values.attendancePeriodId = allValues.Row.id;
                values.attendanceTypeId = allValues.AttendanceTypeID;
                values.attendanceReasonId = allValues.AttendanceReasonID;
                values.comment = allValues.Comment
                values.HideCommentInFA = allValues.HideCommentInFA;
                values.HideCommentInSA = allValues.HideCommentInSA;
                values.HideCommentInTA = allValues.HideCommentInTA;
                values.HideCommentInAA = allValues.HideCommentInAA;
                values.HideCommentInSSA = allValues.HideCommentInSSA;
                values.HideTeacherCommentInFA = allValues.HideTeacherCommentInFA;
                values.HideTeacherCommentInSA = allValues.HideTeacherCommentInSA;

                attendancePeriodValues.push(values);
            });

            // not already dirty from Guardian Notified or End Date changing, check if anything in AttendancePeriodForm table is dirty
            if (!dirtyPeriods)
            {
                dirtyPeriods = skyward.changeTracking.isDirty(formControls.attendanceEntryTable);
            }

            return attendancePeriodValues;
        };

        var setAttendancePeriodEels = function (e)
        {
            // Don't update values if triggered from code (Return on Save & Clear) or if editableAttendancePeriodControls is currently empty
            if ((e && e.originalEvent === undefined && e.type == 'change') ||
                !editableAttendancePeriodControls || !editableAttendancePeriodControls.length)
            {
                return;
            }

            if (e && e.currentTarget)
            {
                var checkPeriodRange = function ()
                {
                    var startPeriod = skyward.controls.getValue(formControls.startPeriodEel);
                    var endPeriod = skyward.controls.getValue(formControls.endPeriodEel);
                    if (startPeriod === undefined || startPeriod === '' || endPeriod === undefined || endPeriod === '')
                    {
                        return false;
                    }
                    return true;
                }

                //wait for both start and end to be filled
                if (formControls.allDayCkb && e.currentTarget == formControls.allDayCkb[0] && !skyward.controls.getValue(formControls.allDayCkb) && !checkPeriodRange())
                {
                    return;
                }
                else if (((formControls.startPeriodEel && e.currentTarget == formControls.startPeriodEel[0]) || (formControls.endPeriodEel && e.currentTarget == formControls.endPeriodEel[0])) && !checkPeriodRange())
                {
                    return;
                }
            }

            var formValues = getCurrentFormValues();

            if (formValues.allDay)
            {
                formValues.startPeriodId = editableAttendancePeriodControls[0].id;
                formValues.endPeriodId = editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].id;
                if (startPeriodAsteriskSpan.get(0))
                {
                    startPeriodAsteriskSpan.hide();
                }

                if (endPeriodAsteriskSpan.get(0))
                {
                    endPeriodAsteriskSpan.hide();
                }
            }
            else
            {
                periodEELControlsRenderManager();
                if (startPeriodAsteriskSpan.get(0))
                {
                    startPeriodAsteriskSpan.show();
                }

                if (endPeriodAsteriskSpan.get(0))
                {
                    endPeriodAsteriskSpan.show();
                }
            }

            hideErrors();
            var isInRange = formValues.allDay;

            $.each(allAttendancePeriodControls, function (index, row)
            {
                isInRange = isInRange || row.id == formValues.startPeriodId;

                var attendancePeriodControlsContainsID = function (id)
                {
                    var collectionContainsValue = false;
                    $.each(editableAttendancePeriodControls, function (index, row)
                    {
                        if (row.id === id)
                        {
                            collectionContainsValue = true;
                            return;
                        }
                    });
                    return collectionContainsValue;
                };

                var getRowValues = function (id)
                {
                    var attendanceTypeId = null;
                    var attendanceReasonId = null;
                    var comment = null;
                    var hideCommentInTA = null;
                    var hideCommentInAA = null;
                    var hideCommentInSSA = null;
                    var hideCommentInFA = null;
                    var hideCommentInSA = null;
                    var hideTeacherCommentInFA = null;
                    var hideTeacherCommentInSA = null;
                    $.each(editableAttendancePeriodControls, function (index, row)
                    {
                        if (row.id === id)
                        {
                            attendanceTypeId = skyward.controls.getValue(row.controls.attendanceTypeEel);
                            attendanceReasonId = skyward.controls.getValue(row.controls.attendanceReasonEel);
                            comment = skyward.controls.getValue(row.controls.commentTb);

                            hideCommentInTA = skyward.controls.getValue(row.controls.HideCommentInTA);
                            hideCommentInAA = skyward.controls.getValue(row.controls.HideCommentInAA);
                            hideCommentInSSA = skyward.controls.getValue(row.controls.HideCommentInSSA);
                            hideCommentInFA = skyward.controls.getValue(row.controls.HideCommentInFA);
                            hideCommentInSA = skyward.controls.getValue(row.controls.HideCommentInSA);
                            hideTeacherCommentInFA = skyward.controls.getValue(row.controls.HideTeacherCommentInFA);
                            hideTeacherCommentInSA = skyward.controls.getValue(row.controls.HideTeacherCommentInSA);

                            if (hideTeacherCommentInFA == null || hideTeacherCommentInFA == "")
                            {
                                hideTeacherCommentInFA = false;
                            }
                            if (hideTeacherCommentInSA == null || hideTeacherCommentInSA == "")
                            {
                                hideTeacherCommentInSA = false;
                            }
                            return;
                        }
                    });

                    var values =
                    {
                        AttendanceTypeID: attendanceTypeId,
                        AttendanceReasonID: attendanceReasonId,
                        Comment: comment,
                        HideCommentInTA: hideCommentInTA,
                        HideCommentInAA: hideCommentInAA,
                        HideCommentInSSA: hideCommentInSSA,
                        HideCommentInFA: hideCommentInFA,
                        HideCommentInSA: hideCommentInSA,
                        HideTeacherCommentInFA: hideTeacherCommentInFA,
                        HideTeacherCommentInSA: hideTeacherCommentInSA
                    };
                    return values;
                };

                if (attendancePeriodControlsContainsID(row.id))
                {
                    var attendanceTypeId = formValues.attendanceTypeId;
                    var attendanceReasonId = formValues.attendanceReasonId;
                    var comment = formValues.comment;

                    if (e && e.currentTarget)
                    {
                        // if manually changing the type, reason or comment in the quick entry, only update the corresponding column
                        if (formControls.commentTb && e.currentTarget == formControls.commentTb[0])
                        {
                            var values = getRowValues(row.id);
                            attendanceTypeId = values.AttendanceTypeID || attendanceTypeId;
                            attendanceReasonId = values.AttendanceReasonID || attendanceReasonId;
                        }
                        else if (formControls.attendanceReasonEel && e.currentTarget == formControls.attendanceReasonEel[0])
                        {
                            var values = getRowValues(row.id);
                            attendanceTypeId = values.AttendanceTypeID || attendanceTypeId;
                            comment = values.Comment || comment;
                        }
                        else if (formControls.attendanceTypeEel && e.currentTarget == formControls.attendanceTypeEel[0])
                        {
                            var values = getRowValues(row.id);
                            attendanceReasonId = values.AttendanceReasonID || attendanceReasonId;
                            comment = values.Comment || comment;
                        }
                        else if (formControls.commentAttendanceCommentPrivacySettingContainer && e.currentTarget == formControls.commentAttendanceCommentPrivacySettingContainer[0])
                        {
                            var values = getRowValues(row.id);
                            attendanceTypeId = values.AttendanceTypeID || attendanceTypeId;
                            attendanceReasonId = values.AttendanceReasonID || attendanceReasonId;
                            if (e.commentUpdatedToEmpty !== true)
                            {
                                comment = values.Comment || comment;
                            }
                            var hideData;

                            if (formControls.periodCommentHideInFA.length > 0)
                            {
                                hideData = {
                                    hideInFA: formValues.periodCommentHideInFA,
                                    hideInSA: formValues.periodCommentHideInSA,
                                    hideInTA: formValues.periodCommentHideInTA,
                                    hideInAA: formValues.periodCommentHideInAA,
                                    hideInSSA: formValues.periodCommentHideInSSA,
                                };
                            }
                            else
                            {
                                hideData = {
                                    hideInFA: formValues.dayCommentHideInFA,
                                    hideInSA: formValues.dayCommentHideInSA,
                                    hideInTA: formValues.dayCommentHideInTA,
                                    hideInAA: formValues.dayCommentHideInAA,
                                    hideInSSA: formValues.dayCommentHideInSSA,
                                };
                            }
                            row.controls.OfficeCommentButtonsContainer.trigger("updateButtonStatus", hideData);
                        }
                    }

                    if (isInRange)
                    {
                        setAttendancePeriodControls(row, attendanceTypeId, attendanceReasonId, comment);
                    }
                    else
                    {
                        var onlySelectedPeriods = formValues.allDay === true;
                        if (onlySelectedPeriods)
                        {
                            clearAttendancePeriodValues(row);
                        }
                        else
                        {
                            restoreAttendancePeriodOriginalValues(row);
                        }
                    }
                }

                if (row.id == formValues.endPeriodId)
                {
                    isInRange = false;
                }
            });

            performValidatePeriodsAjax();
        };

        var clearAttendancePeriodValues = function (row)
        {
            setAttendancePeriodControls(
                row,
                null,
                null,
                null);
            hideAttendancePeriodControls(row);
        };

        var restoreAttendancePeriodOriginalValues = function (row)
        {
            var rowAttendanceTypeOriginalValue = skyward.controls.getOriginalValue(row.controls.attendanceTypeEel);
            setAttendancePeriodControls(
                row,
                rowAttendanceTypeOriginalValue,
                skyward.controls.getOriginalValue(row.controls.attendanceReasonEel),
                skyward.controls.getOriginalValue(row.controls.commentTb));

            if (!rowAttendanceTypeOriginalValue)
            {
                hideAttendancePeriodControls(row);
            }
            else
            {
                showAttendancePeriodControls(row, true);
            }
        };

        /**
         * @param {AttendanceRow} row - Attendance Period/Type/Reason/Comment
         * @param {number} attendanceTypeId - Attendance Type code eel value
         * @param {number} attendanceReasonId - Attendance Reason code eel value
         * @param {string} comment - Attendance Comment
         */
        var setAttendancePeriodControls = function (row, attendanceTypeId, attendanceReasonId, comment)
        {
            var typeViewPart = row.controls.attendanceTypeEel.find('input.attendancePeriodTypeElement');
            var reasonViewPart = row.controls.attendanceReasonEel.find('input.attendancePeriodReasonElement');
            var commentViewPart = row.controls.commentTb;

            var typeIsEnabled = getPartIsEnabled(typeViewPart, attendanceTypeId);
            var reasonIsEnabled = getPartIsEnabled(reasonViewPart, attendanceReasonId);
            var commentIsEnabled = getPartIsEnabled(commentViewPart, comment);

            if (typeIsEnabled === true && reasonIsEnabled === true && commentIsEnabled === true)
            {
                validatePeriodAttendancePeriodIDs[row.id] =
                {
                    Row: row,
                    AttendanceTypeID: attendanceTypeId,
                    AttendanceReasonID: attendanceReasonId,
                    Comment: comment
                };
            }
        };

        var getPartIsEnabled = function (part)
        {
            return part && part.is(':disabled,[readonly],.ui-disabled') === false;
        };

        var showAttendancePeriodControls = function (row, checkRowForHideValue)
        {
            var formValues = getCurrentFormValues();
            row.controls.commentTb.show();
            row.controls.attendanceReasonEel.show();
            row.controls.OfficeCommentButtonsContainer.show();
            var hideData = {};

            if (checkRowForHideValue)
            {
                var rowValues = getAttendancePeriodsValuesForRow(row);

                hideData = {
                    hideInFA: rowValues.HideCommentInFA,
                    hideInSA: rowValues.HideCommentInSA,
                    hideInTA: rowValues.HideCommentInTA,
                    hideInAA: rowValues.HideCommentInAA,
                    hideInSSA: rowValues.HideCommentInSSA,
                };
            }
            else
            {
                hideData = {
                    hideInFA: formValues.periodCommentHideInFA,
                    hideInSA: formValues.periodCommentHideInSA,
                    hideInTA: formValues.periodCommentHideInTA,
                    hideInAA: formValues.periodCommentHideInAA,
                    hideInSSA: formValues.periodCommentHideInSSA,
                };
            }

            row.controls.OfficeCommentButtonsContainer.trigger("updateButtonStatus", hideData);
        };

        var hideAttendancePeriodControls = function (row)
        {
            row.controls.commentTb.hide();
            row.controls.attendanceReasonEel.hide();
            row.controls.OfficeCommentButtonsContainer.hide();
        };

        var updateStudentAttendancePanels = function (errorData)
        {
            var data = {};
            data.StartDate = formControls.startDateTb.val();
            data.EndDate = formControls.endDateTb.val();

            // Only fire this ajax if dates have changed since these panels were rendered
            if (data.StartDate !== formControls.getGeneratedAttendancePeriodsStartDate().val() || data.EndDate !== formControls.getGeneratedAttendancePeriodsEndDate().val())
            {
                // disable controls while ajax is in flight
                hidePeriodEELs();
                skyward.window.loadContent('attendanceEntryTool_CurrentStudentBrowseArea', 'Attendance', controllerObject, 'GenerateCurrentStudentAttendanceBrowse', studentId, data);
                skyward.window.loadContent('attendanceEntryTool_GeneratedAttendancePeriods', 'Attendance', controllerObject, 'GeneratedAttendancePeriods', studentId, data).done(function ()
                {
                    // assign new entry table reference
                    formControls.attendanceEntryTable = $('.attendanceEntryTable');
                    formControls.attendanceEntryTable.off('change').on('change', attendanceEntryTableChange);

                    // re-enable controls
                    showPeriodEELs();
                    periodEELControlsRenderManager();
                    displayErrorMessages(errorData);
                });
            }
        };

        var changeEndDate = function (e)
        {
            var startDate = skyward.controls.getValue(formControls.startDateTb)
            var endDate = skyward.controls.getValue(formControls.endDateTb);

            if (e.target.id === formControls.startDateTb.attr('id') && startDate !== endDate)
            {
                // truthy start date means no empty string or NaN, set endDate
                if (startDate)
                {
                    skyward.controls.setValue(formControls.endDateTb, startDate);
                }
                else
                {
                    skyward.controls.clearValue(formControls.endDateTb);
                }
            }
        };

        var validateDates = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/ValidateDates',
                type: "POST",
                dataType: "JSON",
                data:
                {
                    StudentID: studentId,
                    StartDate: formControls.startDateTb.val(),
                    EndDate: formControls.endDateTb.val(),
                    CurrentYearId: currentSchoolYearId
                },
                success: function (data)
                {
                    studentNotEnrolledInDates = !data.success;
                    updateStudentAttendancePanels(data);
                    updateFromAjax(data);
                }
            });
        };

        var updateFromAjax = function (data)
        {
            if (data.Update)
            {
                for (var field in data.Update)
                {
                    var currentValue = skyward.controls.getValue("#" + field);
                    var newValue = data.Update[field];

                    if (currentValue != newValue)
                    {
                        skyward.controls.setValue("#" + field, newValue);
                    }
                }
            }
        }

        var displayErrorMessages = function (data)
        {
            skyward.validation.displayValidationMessages(data, attendanceEntryContainerDiv, attendanceEntryErrorsDiv);
        };

        var periodEELControlsRenderManager = function ()
        {
            // hold onto the date values last used to generated attendance periods
            formControls.getGeneratedAttendancePeriodsStartDate().val(formControls.startDateTb.val());
            formControls.getGeneratedAttendancePeriodsEndDate().val(formControls.endDateTb.val());

            if (studentNotEnrolledInDates)
            {
                hidePeriodEELs();
                showEnrollmentError();
                return true;
            }
            else
            {
                showPeriodEELs();
                hideErrors();
                return false;
            }
        };

        var hidePeriodEELs = function ()
        {
            skyward.controls.disable(formControls.startPeriodEel.children());
            formControls.startPeriodEel.children('.button').addClass('hidden');
            skyward.controls.disable(formControls.endPeriodEel.children());
            formControls.endPeriodEel.children('.button').addClass('hidden');
            skyward.controls.disable(formControls.allDayCkb);

            if (formControls.attendanceEntryTable)
            {
                formControls.attendanceEntryTable.hide();
            }
        };

        var showPeriodEELs = function ()
        {
            var allDay = skyward.controls.getValue(formControls.allDayCkb);

            if (!allDay)
            {
                skyward.controls.enable(formControls.startPeriodEel.children());
                formControls.startPeriodEel.children('.button').removeClass('hidden');
                skyward.controls.enable(formControls.endPeriodEel.children());
                formControls.endPeriodEel.children('.button').removeClass('hidden');
            }

            skyward.controls.enable(formControls.allDayCkb);

            formControls.attendanceEntryTable.show();
        };

        // Custom tab order for Attendance Entry by Student screen
        var tabOverride = function (e)
        {
            if (e.keyCode != 9)
            {
                return;
            }

            e.preventDefault();
            var formValues = getCurrentFormValues();

            switch (e.target.id)
            {
                case nameSelectorTb.attr('id'):
                case formControls.processRequestWithExistingAttendance.attr('id'):
                    if (e.shiftKey)
                    {
                        formControls.isGuardianNotifiedCkb.focus();
                    }
                    else
                    {
                        formControls.allDayCkb.focus();
                    }
                    break;
                case formControls.cancelBtn.attr('id'):
                    if (e.shiftKey)
                    {
                        (formControls.saveAndBackBtn.length > 0) ? formControls.saveAndBackBtn.focus() : formControls.saveBtn.focus();
                    }
                    else
                    {
                        formControls.allDayCkb.focus();
                    }
                    break;
                case formControls.startDateTb.attr('id'):
                    if (e.shiftKey)
                    {
                        if (formControls.cancelBtn.hasClass('dirty'))
                        {
                            formControls.cancelBtn.focus();
                        }
                        else if (formControls.processRequestWithExistingAttendance.is(':visible'))
                        {
                            formControls.processRequestWithExistingAttendance.focus();
                        }
                        else
                        {
                            nameSelectorTb.focus();
                        }
                    }
                    else
                    {
                        formControls.endDateTb.focus();
                    }
                    break;
                case formControls.startPeriodEelCodeTb.attr('id'):
                    if (e.shiftKey)
                    {
                        formControls.allDayCkb.focus();
                    }
                    else
                    {
                        if (formValues.startPeriodId == '' && formValues.endPeriodId == '')
                        {
                            editableAttendancePeriodControls[0].controls.attendanceTypeEelCodeTb.focus();
                        }
                        else
                        {
                            formControls.endPeriodEelCodeTb.focus();
                        }
                    }
                    break;
                case formControls.isGuardianNotifiedCkb.attr('id'):
                    if (e.shiftKey)
                    {
                        formControls.commentTb.focus();
                    }
                    else if (formControls.cancelBtn.hasClass('dirty'))
                    {
                        (formControls.saveAndBackBtn.length > 0) ? formControls.saveAndBackBtn.focus() : formControls.saveBtn.focus();
                    }
                    else if (formControls.processRequestWithExistingAttendance.is(':visible'))
                    {
                        formControls.processRequestWithExistingAttendance.focus();
                    }
                    else
                    {
                        formControls.allDayCkb.focus();
                    }
                    break;
                case editableAttendancePeriodControls[0].controls.attendanceTypeEelCodeTb.attr('id'):
                    if (e.shiftKey)
                    {
                        formControls.startPeriodEelCodeTb.focus();
                    }
                    else
                    {
                        skyward.tabbing.focusAfter(editableAttendancePeriodControls[0].controls.attendanceTypeEelCodeTb);
                    }
                    break;
                case editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.attendanceTypeEelCodeTb.attr('id'):
                    if (e.shiftKey)
                    {
                        skyward.tabbing.focusBefore(editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.attendanceTypeEelCodeTb);
                    }
                    else if (editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.commentTb.is(':visible'))
                    {
                        skyward.tabbing.focusAfter(editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.attendanceTypeEelCodeTb);
                    }
                    else
                    {
                        if (formControls.cancelBtn.hasClass('dirty'))
                        {
                            (formControls.saveAndBackBtn.length > 0) ? formControls.saveAndBackBtn.focus() : formControls.saveBtn.focus();
                        }
                        else if (formControls.processRequestWithExistingAttendance.is(':visible'))
                        {
                            formControls.processRequestWithExistingAttendance.focus();
                        }
                        else
                        {
                            formControls.allDayCkb.focus();
                        }
                    }
                    break;
                case editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.commentTb.attr('id'):
                    if (e.shiftKey)
                    {
                        skyward.tabbing.focusBefore(editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.commentTb);
                    }
                    else
                    {
                        if (formControls.cancelBtn.hasClass('dirty'))
                        {
                            (formControls.saveAndBackBtn.length > 0) ? formControls.saveAndBackBtn.focus() : formControls.saveBtn.focus();
                        }
                        else if (formControls.processRequestWithExistingAttendance.is(':visible'))
                        {
                            formControls.processRequestWithExistingAttendance.focus();
                        }
                        else
                        {
                            formControls.allDayCkb.focus();
                        }
                    }
                    break;
            }
        };

        var toggleCurrentRow = function ()
        {
            var clickedRow = $(this);
            if (clickedRow.get(0) != currentStudentAttendanceSelectedRow.get(0))
            {
                clickedRow.addClass('current');
                currentStudentAttendanceSelectedRow.removeClass('current');
                currentStudentAttendanceSelectedRow = clickedRow;
            }
        };

        var showNoChangeError = function ()
        {
            formControls.attendanceEntryErrors.text('No changes were made to the Attendance Record').show();
        };

        var showEnrollmentError = function ()
        {
            formControls.attendanceEntryErrors.text('Student is not enrolled for all of the specified dates').show();
        };

        var showNoEditablePeriodsError = function ()
        {
            formControls.attendanceEntryErrors.text('No editable periods available').show();
        };

        var hideErrors = function ()
        {
            formControls.attendanceEntryErrors.text('').hide();
        };

        var attendanceEntryToolAddEntry = function (buttonName, button, parentMethod)
        {
            formControls.saveBtn.removeClass('dirty');
            formControls.cancelBtn.removeClass('dirty');

            if (formControls.saveAndBackBtn.is(':visible'))
            {
                formControls.saveAndBackBtn.removeClass('dirty');
            }

            button.off('click');
            $.when(skyward.attendanceEntryTools.addEntry(buttonName)).done(function ()
            {
                button.on('click', parentMethod);
            });
        };

        var attendanceEntryToolAddEntrySave = function ()
        {
            attendanceEntryToolAddEntry('save', formControls.saveBtn, attendanceEntryToolAddEntrySave);
        };

        var attendanceEntryToolAddEntrySaveAndBack = function ()
        {
            attendanceEntryToolAddEntry('saveandback', formControls.saveAndBackBtn, attendanceEntryToolAddEntrySaveAndBack);
        };

        var attendanceEntryToolAddEntryProcessRequestWithExistingAttendance = function ()
        {
            attendanceEntryToolAddEntry('processrequestwithexistingattendance', formControls.processRequestWithExistingAttendance, attendanceEntryToolAddEntryProcessRequestWithExistingAttendance);
        };

        var toggleVisibilityProcessRequestWithExistingAttendance = function (event)
        {
            if (formControls.processRequestWithExistingAttendance)
            {
                if (skyward.changeTracking.isDirty() == true || nonPeriodFormControlsThatAffectButtonsAreDirty(formControls, isSpanningMultipleDays(formControls)))
                {
                    formControls.processRequestWithExistingAttendance.addClass('displayNone');
                }
                else
                {
                    formControls.processRequestWithExistingAttendance.removeClass('displayNone');
                }
            }
        };

        var isSpanningMultipleDays = function (formControls)
        {
           return formControls.startDateTb.val() != formControls.endDateTb.val();
        };

        var nonPeriodFormControlsThatAffectButtonsAreDirty = function (formControls, multipleDays)
        {
           return skyward.changeTracking.isDirty(formControls.isGuardianNotifiedCkb.parent()) ||
                skyward.changeTracking.isDirty(formControls.useDayStatusOverrideCb.parent()) ||
                skyward.changeTracking.isDirty(formControls.dayStatusOverrideEel.parent()) ||
                skyward.changeTracking.isDirty(formControls.dayComment.parent()) ||
                skyward.changeTracking.isDirty(formControls.replyToGuardianTb.parent()) ||
                skyward.changeTracking.isDirty(formControls.useMetMinutesRequiredOverrideCb.parent()) ||
                skyward.changeTracking.isDirty(formControls.metMinutesRequiredOverrideCb.parent()) ||
                (multipleDays && skyward.changeTracking.isDirty(formControls.endDateTb.parent()));
        };

        var performAddEntryAjax = function (button)
        {
            var formValues = getCurrentFormValues();

            var multipleDays = isSpanningMultipleDays(formControls);

            // isDirty does a .find on the parameter, so we pass the Guardian Notified checkbox's parent to detect dirtiness
            dirtyPeriods = nonPeriodFormControlsThatAffectButtonsAreDirty(formControls, multipleDays);

            var periods = JSON.stringify(getCurrentAttendancePeriodValues());
            if (!periods)
            {
                dirtySaveControls();
                showNoEditablePeriodsError();
                return false;
            }

            var contentArea = $('.js-attendanceEntryByStudentAddEntry');
            var cmaObject = skyward.contentMessageArea.getContentMessageArea(contentArea);
            cmaObject.resetInformation();

            var attachmentSessionUploadIDs = [];

            var uploadFileInput = formControls.attachments.find("#UploadFile").first();

            if (uploadFileInput.length > 0 && uploadFileInput.val())
            {
                var fileData = JSON.parse(uploadFileInput.val());
                fileData.forEach(function (file)
                {
                    attachmentSessionUploadIDs.push(file.sessionFileUploadID);
                });
            }

            if (dirtyPeriods || attachmentSessionUploadIDs.length > 0 || button === 'processrequestwithexistingattendance')
            {
                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/AddEntry',
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            StudentID: studentId,
                            StartDate: formValues.startDate,
                            EndDate: formValues.endDate,
                            Comment: skyward.extensions.encodeHtml(formValues.comment),
                            DayComment: skyward.extensions.encodeHtml(formValues.dayComment),
                            DayCommentHideInFA: formValues.dayCommentHideInFA,
                            DayCommentHideInSA: formValues.dayCommentHideInSA,
                            DayCommentHideInTA: formValues.dayCommentHideInTA,
                            DayCommentHideInAA: formValues.dayCommentHideInAA,
                            DayCommentHideInSSA: formValues.dayCommentHideInSSA,
                            IsGuardianNotified: formValues.isGuardianNotified,
                            UseAttendanceTypeDayStatusOverride: formValues.useAttendanceTypeDayStatusOverride,
                            UseMetMinutesRequiredOverride: formValues.useMetMinutesRequiredOverride,
                            MetMinutesRequiredOverride: formValues.metMinutesRequiredOverride,
                            UseAttendanceTypeDayStatusOverride: formValues.useAttendanceTypeDayStatusOverride,
                            AttendanceTypeIDDayStatusOverride: formValues.attendanceTypeIDDayStatusOverride,
                            StudentAttendancePeriods: skyward.extensions.encodeHtml(periods),
                            StartPeriod: formValues.startPeriodId,
                            EndPeriod: formValues.endPeriodId,
                            AllDay: formValues.allDay,
                            CurrentYearId: currentSchoolYearId,
                            AttendanceReasonID: formValues.attendanceReasonId,
                            AttendanceTypeID: formValues.attendanceTypeId,
                            AttachmentSessionFileUploadIDs: JSON.stringify(attachmentSessionUploadIDs),
                            StudentAbsenceRequestID: studentAbsenceRequestId,
                            ReplyToGuardian: skyward.extensions.encodeHtml(formValues.replyToGuardian),
                            warninghash: formValues.warninghash
                        },
                        success: function (data)
                        {
                            if (data.success)
                            {
                                skyward.attendanceEntryTools.clearFields(data.deletedStudentAttendance);

                                if (button === 'saveandback')
                                {
                                    skyward.window.setSkipUnloadCheck(true);

                                    if (studentAbsenceRequestId)
                                    {
                                        skyward.window.loadContent('full', 'Attendance', 'StudentAbsenceRequest', 'GuardianEnteredRequests');
                                    }
                                    else
                                    {
                                        skyward.window.returnToPrevious('saveandback');
                                    }
                                }
                                else
                                {
                                    nameSelectorTb.focus();

                                    //show message for record saved
                                    cmaObject.setConfirmationMessage(skyward.contentMessageArea.getDefaultConfirmationMessage());

                                    if (data.showSomePeriodsWereNotUpdatedMessage === true)
                                    {
                                        cmaObject.setInformationMessage("Attendance records were only created for periods that did not previously have records");
                                        cmaObject.showInformation();
                                    }
                                    else if (data.showSomePeriodsWereNotCreatedMessage === true)
                                    {
                                        cmaObject.setInformationMessage("Attendance records were only updated for periods that previously had records");
                                        cmaObject.showInformation();
                                    }

                                    cmaObject.showConfirmation();

                                    if (studentAbsenceRequestId)
                                    {
                                        skyward.window.loadContent('full', 'Attendance', 'StudentAbsenceRequest', 'StudentAbsenceRequest_Next', studentAbsenceRequestId);
                                    }
                                }
                            }
                            else
                            {
                                dirtySaveControls();

                                if (!$.isEmptyObject(data.errors) || !$.isEmptyObject(data.warnings))
                                {
                                    displayErrorMessages(data);

                                    if (data.errors['Base'] || data.warnings['Base'])
                                    {
                                        formControls.attendanceEntryErrors.show();
                                    }
                                }
                            }
                        }
                    });
            }
            else
            {
                dirtySaveControls();
                showNoChangeError();
                return false;
            }
        };

        var performValidatePeriodsAjax = function ()
        {
            return $.ajax({
                url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/ValidatePeriods',
                type: 'POST',
                data: {
                    AttendancePeriodIDs: JSON.stringify(Object.keys(validatePeriodAttendancePeriodIDs)),
                    StartDate: formControls.startDateTb.encodedVal(),
                    EndDate: formControls.endDateTb.encodedVal(),
                    StudentID: studentId
                },
                success: function (data)
                {
                    // AttendancePeriod response is Object where Key is AttendancePeriodID and value is ReadOnly
                    if (data.AttendancePeriods)
                    {
                        $.each(data.AttendancePeriods, function (attendancePeriodID, readOnly)
                        {
                            /** @type {PeriodRowData} */
                            var rowData = validatePeriodAttendancePeriodIDs[attendancePeriodID];

                            if (rowData != null)
                            {
                                if (!readOnly)
                                {
                                    // For these code eels, if the value isn't changing we don't call setValue to avoid the redundant "codeeel" ajax that would otherwise send
                                    var attendanceTypeChanged = (rowData.AttendanceTypeID || "") != skyward.controls.getValue(rowData.Row.controls.attendanceTypeEel);
                                    if (attendanceTypeChanged) skyward.controls.setValue(rowData.Row.controls.attendanceTypeEel, rowData.AttendanceTypeID);
                                    var attendanceReasonChanged = (rowData.AttendanceReasonID || "") != skyward.controls.getValue(rowData.Row.controls.attendanceReasonEel);
                                    if (attendanceReasonChanged) skyward.controls.setValue(rowData.Row.controls.attendanceReasonEel, rowData.AttendanceReasonID);

                                    // For this textbox, suppressing the change event doesn't matter as much, fire away
                                    skyward.controls.setValue(rowData.Row.controls.commentTb, rowData.Comment);

                                    if (!rowData.AttendanceTypeID)
                                    {
                                        hideAttendancePeriodControls(rowData.Row);
                                    }
                                    else
                                    {
                                        showAttendancePeriodControls(rowData.Row, true);
                                    }
                                }
                                else
                                {
                                    hideAttendancePeriodControls(rowData.Row);
                                }
                            }
                        });

                        attendanceTypeUpdate();
                    }
                }
            });
        };

        /**
         * Calls setAttendancePeriodControls whenever anything in the right panel is updated (manually by the user or otherwise)
         * @param {Event} e - event of change
         */
        var attendanceEntryTableChange = function (e)
        {
            if (e && e.target)
            {
                var attendancePeriodRow = $(e.target).parents('.attendancePeriodRow').eq(0);
                var rowData = getAttendancePeriodRowData(attendancePeriodRow);
                var valuesData = getAttendancePeriodsValuesForRow(rowData);

                setAttendancePeriodControls(rowData, valuesData.AttendanceTypeID, valuesData.AttendanceReasonID, valuesData.Comment);
            }
        };

        var attendanceTypeUpdate = function (button)
        {
            var formValues = getCurrentFormValues();
            var periods = JSON.stringify(getCurrentAttendancePeriodValues());

            return $.ajax(
                {
                    url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/UpdateAttendanceType',
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        StudentAttendancePeriods: skyward.extensions.encodeHtml(periods),
                        StudentID: studentId,
                        StartDate: formValues.startDate,
                        EndDate: formValues.endDate,
                        Comment: skyward.extensions.encodeHtml(formValues.comment),
                        DayComment: skyward.extensions.encodeHtml(formValues.dayComment),
                        IsGuardianNotified: formValues.isGuardianNotified,
                        StartPeriod: formValues.startPeriodId,
                        EndPeriod: formValues.endPeriodId,
                        AllDay: formValues.allDay,
                        CurrentYearId: currentSchoolYearId,
                        AttendanceReasonID: formValues.attendanceReasonId,
                        AttendanceTypeID: formValues.attendanceTypeId,
                        StudentAbsenceRequestID: studentAbsenceRequestId,
                        ReplyToGuardian: skyward.extensions.encodeHtml(formValues.replyToGuardian),
                        warninghash: formValues.warninghash
                    },
                    success: function (data)
                    {
                        updateFromAjax(data);
                    }
                });
        };

        var attendanceTypeUpdate = function (button)
        {
            var formValues = getCurrentFormValues();
            var periods = JSON.stringify(getCurrentAttendancePeriodValues());

            return $.ajax(
                {
                    url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/UpdateAttendanceType',
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        StudentAttendancePeriods: skyward.extensions.encodeHtml(periods),
                        StudentID: studentId,
                        StartDate: formValues.startDate,
                        EndDate: formValues.endDate,
                        Comment: skyward.extensions.encodeHtml(formValues.comment),
                        DayComment: skyward.extensions.encodeHtml(formValues.dayComment),
                        IsGuardianNotified: formValues.isGuardianNotified,
                        StartPeriod: formValues.startPeriodId,
                        EndPeriod: formValues.endPeriodId,
                        AllDay: formValues.allDay,
                        CurrentYearId: currentSchoolYearId,
                        AttendanceReasonID: formValues.attendanceReasonId,
                        AttendanceTypeID: formValues.attendanceTypeId,
                        StudentAbsenceRequestID: studentAbsenceRequestId,
                        ReplyToGuardian: skyward.extensions.encodeHtml(formValues.replyToGuardian),
                        warninghash: formValues.warninghash
                    },
                    success: function (data)
                    {
                        updateFromAjax(data);
                    }
                });
        };

        skyward.attendanceEntryTools.addEntry = function (button)
        {
            performValidatePeriodsAjax()
                .done(function ()
                {
                    performAddEntryAjax(button);
                })
                .then(function () { validatePeriodAttendancePeriodIDs = {}; });
        };

        skyward.attendanceEntryTools.clearFields = function (deletingAttendance)
        {
            displayErrorMessages(null);

            $.each(formControls, function (index, control)
            {
                // instanceof Function handles the GeneratedAttendancePeriodStart/EndDate getters
                control = control instanceof Function ? control() : control;
                var originalValue = control.data('original-value');

                if (control.hasClass('codeEEL'))
                {
                    var codeEELValue = control.children('.codeEELValue');
                    skyward.controls.setDataAttribute(codeEELValue, 'original-value', deletingAttendance ? '' :codeEELValue.val());// codeEELValue.data('original-value'));
                    skyward.controls.setDataAttribute(codeEELValue, 'dirty', false);
                }
                else if (control.is(':checkbox') && control.attr('name') !== 'AllDay')
                {
                    skyward.controls.setDataAttribute(control, 'original-value', deletingAttendance ? false : control.prop('checked'));
                    skyward.controls.setValue(control, deletingAttendance ? false : control.data('original-value'));
                }

                if (!control.hasClass('datePicker'))
                {
                    if (control.hasClass("commentPrivacyTextArea"))
                    {
                        skyward.controls.setDataAttribute(control, 'original-value', deletingAttendance ? '' : control.val());
                        control.trigger("clearButtonStatus");
                    }

                    skyward.controls.setValue(control, originalValue, true);
                }

                // make sure this works with day status
                skyward.controls.setDataAttribute(control, 'dirty', 'false');

                // reset dirty status (re-hides Save/Cancel buttons)
                if (control.hasClass('dirty'))
                {
                    control.removeClass('dirty');
                    skyward.controls.setDataAttribute(control, 'dirty', 'false');
                }
            });

            skyward.controls.enable(formControls.startPeriodEel.find("a.codeEELButton"));
            skyward.controls.enable(formControls.endPeriodEel.find("a.codeEELButton"));

            if (!studentNotEnrolledInDates)
            {
                skyward.controls.setValue(attendancePeriodLowFilterHdn, skyward.controls.getValue(attendancePeriodMinFilterHdn), true);
                skyward.controls.setValue(attendancePeriodHighFilterHdn, skyward.controls.getValue(attendancePeriodMaxFilterHdn), true);
            }

            validatePeriodAttendancePeriodIDs = {};
            updateStudentAttendancePanels(null);
            formControls.attachments.trigger('clearUploads');
            skyward.changeTracking.clearDirtyList();
            attendanceEntryErrorsDiv.html('');
            skyward.controls.setDataAttribute(attendanceEntryContainerDiv, 'warninghash', '');
            formControls.allDayCkb.focus();
            skyward.dataobjectviewer.getFieldValues.disableButtons('attendanceEntryTool');

            if (loadedWithAttendance)
            {
                dirtySaveControls();
            }
        };

        skyward.attendanceEntryTools.attendanceEntryCancel = function (button)
        {
            var toolbar = $(button.closest(".toolbar"));
            var dovContainer = $("#" + toolbar.data().dovId);
            var data = dovContainer.data();
            var tab = data.tabtoroute !== null ? data.tabtoroute : data.tab;

            var area = data.module;
            var controller = data.object;
            var action = data.screen;
            var id = data.primaryid;
            var popupId = data.popupId;
            var cancelButton = $(button);

            if (cancelButton.hasClass("dirty"))
            {
                var target = "moduleContent";
                var data =
                {
                    tab: tab,
                    skipFiscalYearScopeCheck: "true",
                    isSaveBackButtonVisible: $(entryToolSelector + "IsSaveBackButtonVisible").val()
                };

                skyward.window.loadContent(target, area, controller, action, id, data, popupId);
            }
        }

        skyward.attendanceEntryTools.copyFromGuardianComment = function ()
        {
            if (formControls.guardianComment && formControls.commentTb)
            {
                var guardianComment = skyward.controls.getValue(formControls.guardianComment);
                skyward.controls.setValue(formControls.commentTb, guardianComment, true);
                formControls.commentTb.trigger("keyup");
                var event = {};
                event.currentTarget = formControls.commentTb[0];
                setAttendancePeriodEels(event);
            }
        };

        skyward.attendanceEntryTools.copyFromGuardianCommentDayComment = function ()
        {
            if (formControls.guardianComment && formControls.dayComment)
            {
                var dayComment = skyward.controls.getValue(formControls.guardianComment);
                skyward.controls.setValue(formControls.dayComment, dayComment);
            }
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
)
